import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './tenDayForecastDay.scss';

const TenDayForecastDay = (props) => {
  const {
    day = '',
    idx,
    sky = '',
    hiTemp = '',
    loTemp = '',
    iconCode = '',
    precip = '',
    conditions = '',
    onSlideClick,
  } = props;

  // @todo confirm translation is done properly within the coponent.
  const {
    i18n: {
      __,
    },
  } = wp;

  const isToday = 0 === idx;
  const isWeekend = ('Saturday' === day || 'Sunday' === day);

  const moveTrack = (track, trackPos, newTrackPos, direction) => {
    const trk = track;
    let pos = trackPos;

    const frame = () => {
      if ('right' === direction) {
        pos -= 1;
      } else {
        pos += 1;
      }

      trk.style.left = `${pos}px`;

      if (pos === Math.round(newTrackPos)) {
        clearInterval(animatePos); // eslint-disable-line no-use-before-define
      }
    };
    const animatePos = setInterval(frame, 5);
  };

  const adjustTrack = (expandedDay) => {
    const slider = document.querySelector('.tenDay__days .slick-initialized');
    const trackBox = slider.getBoundingClientRect();
    const track = slider.querySelector('.slick-track');
    const dayBox = expandedDay.getBoundingClientRect();
    const arrW = 44; // width of prev or next arrow.
    const leftBoundary = trackBox.left + arrW;
    const rightBoundary = trackBox.right - arrW;
    const padding = 5; // arbitrary padding.
    const trackPos = parseInt(track.style.left, 10);

    let offset = 0;
    let newTrackPos = 0;
    let dir = '';

    if (dayBox.left < leftBoundary) {
      offset = dayBox.left - leftBoundary;
      newTrackPos = trackPos - (offset - padding);
      dir = 'left';
      moveTrack(track, trackPos, newTrackPos, dir);
    }

    if (dayBox.right > rightBoundary) {
      offset = dayBox.right - rightBoundary;
      newTrackPos = trackPos - (offset + padding);
      dir = 'right';
      moveTrack(track, trackPos, newTrackPos, dir);
    }
  };

  const handleToggle = (event) => {
    const thisDay = event.target.closest('.tenDay__day');
    const daysGroup = thisDay.closest('.tenDay__days');
    const expandedDay = daysGroup.querySelector('.isExpanded');

    if (thisDay.classList.contains('isExpanded')) {
      thisDay.classList.remove('isExpanded');
    } else {
      if (null !== expandedDay) {
        expandedDay.classList.remove('isExpanded');
      }
      thisDay.classList.add('isExpanded');
      setTimeout(() => {
        if (5 <= idx) {
          onSlideClick(4);
        } else {
          onSlideClick(idx);
        }
        adjustTrack(thisDay);
      }, 300);
    }
  };

  const skyAbbrev = sky.replace('Thunderstorm', 'T-Storm');

  return (
    <div
      className={classNames('tenDay__day', { isWeekend })}
      key={`${day}-${conditions}`}
      onClick={handleToggle}
      onKeyDown={handleToggle}
      role="button"
      tabIndex="0"
    >
      <div className="tenDay__inner">
        <div className="tenDay__day-label">
          {isToday ? __('Today', 'nbc') : day.substr(0, 3)}
        </div>
        <div className="tenDay__sky">
          <i className={
            `tenDay__sky-icon weather-icon--${iconCode}`
          }
          />
          <span className="tenDay__sky-text">
            {__(skyAbbrev, 'nbc')}
          </span>
        </div>
        <div className="tenDay__temp">
          <span className="tenDay__temp-hi">
            <span className="weather-page__screen-reader-text">
              {__('High Temperature', 'nbc')}
            </span>
            {hiTemp}º
          </span>
          <span className="tenDay__temp-lo">
            <span className="weather-page__screen-reader-text">
              {__('Low Temperature', 'nbc')}
            </span>
            {loTemp}º
          </span>
        </div>
        <div className="tenDay__precip">
          <span className="weather-page__screen-reader-text">
            {__('Chance of precipitation', 'nbc')}
          </span>
          {precip}%
        </div>
        <i className="tenDay__mobile-expand-icon" />
      </div>
      <div className="tenDay__conditions">
        <span className="weather-page__screen-reader-text">
          Forecast conditions
        </span>
        {__(conditions, 'nbc')}
      </div>
    </div>
  );
};

TenDayForecastDay.propTypes = {
  day: PropTypes.string.isRequired,
  idx: PropTypes.number.isRequired,
  sky: PropTypes.string.isRequired,
  hiTemp: PropTypes.string.isRequired,
  loTemp: PropTypes.string.isRequired,
  iconCode: PropTypes.string.isRequired,
  precip: PropTypes.string.isRequired,
  conditions: PropTypes.string.isRequired,
  onSlideClick: PropTypes.func.isRequired,
};

export default TenDayForecastDay;
